import React from "react";
import AddIcon from "@material-ui/icons/Add";
import CloseIcon from "@material-ui/icons/Close";
import "./FormTabBar.css";

type FormTab = {
  id: string;
  label: string;
};

type FormTabBarProps = {
  tabs: FormTab[];
  activeTabId: string;
  onTabChange: (id: string) => void;
  onTabAdd: () => void;
  onTabClose: (id: string) => void;
};

const FormTabBar: React.FC<FormTabBarProps> = ({
  tabs,
  activeTabId,
  onTabChange,
  onTabAdd,
  onTabClose,
}) => {
  const canClose = true;

  const handleTabKeyDown = (event: React.KeyboardEvent<HTMLDivElement>, tabId: string) => {
    if (event.key === "Enter" || event.key === " ") {
      event.preventDefault();
      onTabChange(tabId);
    }
  };

  return (
    <div className="formTabBar" role="tablist">
      {tabs.map((tab) => (
        <div
          key={tab.id}
          className={`formTab${tab.id === activeTabId ? " formTabActive" : ""}`}
          role="tab"
          tabIndex={tab.id === activeTabId ? 0 : -1}
          aria-selected={tab.id === activeTabId}
          onClick={() => onTabChange(tab.id)}
          onKeyDown={(e) => handleTabKeyDown(e, tab.id)}
        >
          {tab.label}
          {canClose && (
            <button
              type="button"
              className="formTabCloseButton"
              onClick={(e) => {
                e.stopPropagation();
                onTabClose(tab.id);
              }}
              aria-label={`Cerrar ${tab.label}`}
            >
              <CloseIcon style={{ fontSize: 12 }} />
            </button>
          )}
        </div>
      ))}
      <button
        type="button"
        className="formTabAddButton"
        onClick={onTabAdd}
        aria-label="Agregar formulario"
      >
        <AddIcon style={{ fontSize: 26 }} />
      </button>
    </div>
  );
};

export default FormTabBar;
